import React from 'react';
/**
 * Error boundary wrapper to notify "failure" for UFO events of components when there was a re-rendering exception caught inside the `componentDidCatch` event handler
 */
export class UfoErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    for (const exp of this.props.experiences) {
      var _errorInfo$componentS;
      exp.failure({
        metadata: {
          source: 'UfoErrorBoundary',
          reason: 'error',
          error: {
            name: error.name,
            message: error.message,
            infoStack: (_errorInfo$componentS = errorInfo.componentStack) !== null && _errorInfo$componentS !== void 0 ? _errorInfo$componentS : undefined
          }
        }
      });
    }
  }
  render() {
    return this.props.children;
  }
}